import {Button, Form, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import AdhocImageUpload from "./AdhocImageUpload";
import AdhocImageGallary from "./AdhocImageGallary";
import {getExtraCleaningFee} from "../service/JobService";

export function ExtraCleaningFeeModel({show, job, handleSave, handleClose, handleDelete, message, setMessage}) {
    const [extraCleaningFeeData, setExtraCleaningFeeData] = useState({
        description: "", extra_price: "", extra_price_work_order: "", images: []});
    const [isLoading, setIsLoading] = useState(false);
    const refreshExtraCleaningFeeData = () => {

        setIsLoading(true);
        setMessage("");
        getExtraCleaningFee(job.cos_job_id).then(response => {
            if (response.status === 200) {
                response.json().then(data => {
                    setExtraCleaningFeeData(data);
                });
            } else {
                //If no instruction is found, no error, just
            }
        }).finally(() => setIsLoading(false));

    };

    const instructionDate = extraCleaningFeeData.date ? new Date(extraCleaningFeeData.date) : new Date();
    const localDate = instructionDate.toLocaleString();
    const calculatedWorkerPrice = ((Number(extraCleaningFeeData.extra_price) || 0) * 0.7).toFixed(1);  // Returns a string

    useEffect(() => {
        refreshExtraCleaningFeeData();
    }, [job]);

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="custom-modal-width"
               onClick={(e) => e.stopPropagation()}>
            <Form>
                <Modal.Header>
                    <Modal.Title>Extra Cleaning Fee</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label><b>Job ID:</b> {job.cos_job_id}. <b>Date: </b>{job.date}</Form.Label>
                    <Form.Group className="mb-3" controlId="address">
                        <Form.Label>Property Address:</Form.Label>
                        <Form.Control type="text" placeholder="Enter Address"
                                      value={job.full_address}
                                      disabled/>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="address">

                    </Form.Group>
                    <Form.Group className="mb-3" controlId="address">
                        <Form.Label>Updated Date:</Form.Label>
                        <Form.Control type="text" placeholder="Enter Address"
                                      value={localDate}
                                      disabled/>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="units">
                        <Form.Label>Agent Price:</Form.Label>
                        <Form.Control
                            type="number"
                            min="0"
                            disabled={isLoading}
                            value={extraCleaningFeeData.extra_price}
                            onChange={(e) => setExtraCleaningFeeData({
                                ...extraCleaningFeeData,
                                extra_price: e.target.value
                            })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="units">
                        <Form.Label>Worker Price:</Form.Label>
                        <Form.Control
                            type="number"
                            min="0"
                            disabled={isLoading}
                            value={extraCleaningFeeData.extra_price_work_order}
                            onChange={(e) => setExtraCleaningFeeData({
                                ...extraCleaningFeeData,
                                extra_price_work_order: e.target.value
                            })}
                        />
                        {!(extraCleaningFeeData.extra_price_work_order > 0) &&
                            <Form.Text className="text-muted">Default to
                                ${calculatedWorkerPrice} </Form.Text>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="instructions">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control type="text" placeholder="Enter Instructions"
                                      value={extraCleaningFeeData.description}
                                      disabled={isLoading}
                                      onChange={(e) => setExtraCleaningFeeData({
                                          ...extraCleaningFeeData,
                                          description: e.target.value
                                      })}
                        />
                        <Form.Text className="text">
                            Please type notes if you need justifications.
                        </Form.Text>
                    </Form.Group>
                    {message &&
                        <Form.Text className="text-danger">
                            {message}
                        </Form.Text>
                    }
                </Modal.Body>
                <div style={{marginLeft: 20, marginRight: 20}}>
                    <AdhocImageUpload images={extraCleaningFeeData.images}
                                      setImages={(images) => setExtraCleaningFeeData({
                                          ...extraCleaningFeeData,
                                          images
                                      })}/>
                    <AdhocImageGallary images={extraCleaningFeeData.images}
                                       setImages={(images) => setExtraCleaningFeeData({
                                           ...extraCleaningFeeData,
                                           images
                                       })}/>
                </div>
                <Modal.Footer>
                    {extraCleaningFeeData.id &&
                        <Button variant="outline-secondary"
                                disabled={isLoading}
                                onClick={(e) => handleDelete(e)}>
                            Delete
                        </Button>}


                    <Button variant="secondary"
                            disabled={isLoading}
                            onClick={(e) => handleClose(e)}>
                        Close
                    </Button>
                    <Button variant="primary"
                            disabled={isLoading}
                            onClick={(e) => handleSave(e, extraCleaningFeeData)}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};
